import { useSelector } from 'react-redux';

import type { CategoryHubBreadcrumb } from '../CategoryHub.model';
import { selectCategoryHubBreadcrumb } from '../selectors/categoryHub';

export const useCategoryHubBreadcrumb = ():
  | CategoryHubBreadcrumb[]
  | undefined => useSelector(selectCategoryHubBreadcrumb);
